import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'


export default class Sticky extends Component {

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.func,
    ]).isRequired,
  }

  static contextTypes = {
    sticky: PropTypes.shape({
      subscribe: PropTypes.func,
      unsubscribe: PropTypes.func,
    }),
  }

  state = {
    isSticky: false,
  }

  isActive = false
  placeholderNode = null
  node = null

  componentDidMount() {
    const { sticky: { subscribe } } = this.context

    if (typeof subscribe !== 'function') {
      throw new TypeError('Expected Sticky to be mounted within StickyContainer')
    }

    subscribe(this.handleContainerScrollEvent)
  }

  componentWillUnmount() {
    const { sticky: { unsubscribe } } = this.context

    unsubscribe(this.handleContainerScrollEvent)
  }

  handleContainerScrollEvent = () => {
    const { children } = this.props
    const { top } = this.placeholderNode.getBoundingClientRect()

    if (top < 0) {
      if (!this.isActive) {
        this.placeholderNode.style.height = `${this.node.offsetHeight}px`
        this.node.classList.add('sticky')
        this.isActive = true

        if (typeof children === 'function') {
          this.setState({
            isSticky: true,
          })
        }
      }
    }
    else {
      if (this.isActive) {
        this.placeholderNode.style.height = 0
        this.node.classList.remove('sticky')
        this.isActive = false

        if (typeof children === 'function') {
          this.setState({
            isSticky: false,
          })
        }
      }
    }
  }

  render() {
    const { isSticky } = this.state
    const { children } = this.props

    const element = React.cloneElement(
      typeof children === 'function' ? children({ isSticky }) : children,
      {
        ref: (node) => this.node = ReactDOM.findDOMNode(node),
      },
    )

    return (
      <div>
        <div ref={(node) => this.placeholderNode = node} />
        {element}
      </div>
    )
  }
}
